import React, { useMemo } from 'react';
import { equals, filter, length, propEq, map, assoc } from 'ramda';
import { propNotEq } from 'ramda-adjunct';
import { ROLES, TEAM_ROLES } from '../lib/rights';
import { isAdminRole } from '../components/users/utils/roles';

const useUserRoleOptions = ({
  selectedTeam,
  offersOption,
  rolesDisplayed
}) => {
  const roleOptions = useMemo(() => {
    const currentTeamRoles = filter(propEq(selectedTeam, 'teamId'), rolesDisplayed);
    const activeTeamRoles = filter(propNotEq(true, 'isArchived'), currentTeamRoles);
    const isAdmin = Boolean(isAdminRole(activeTeamRoles));
    const hasRoleOnAllOffers = equals(length(activeTeamRoles), length(offersOption));
    const roles = filter(propNotEq(ROLES.superAdmin, 'value'), TEAM_ROLES);
    return map((role) => {
      const currentRoleIsAdmin = propEq(ROLES.admin, 'value', role);
      const disabled = isAdmin || (!currentRoleIsAdmin && hasRoleOnAllOffers);
      return assoc('disabled', disabled, role);
    }, roles);
  }, [selectedTeam, offersOption, rolesDisplayed]);
  return roleOptions;
};

export default useUserRoleOptions;